import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22page.tsx%22,%22import%22:%22Sora%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22weight%22:[%22500%22,%22600%22,%22700%22,%22800%22],%22variable%22:%22--font-sora%22}],%22variableName%22:%22sora%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Sora', 'Sora Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
